<template>
  <BoxCard>
    <template #header>Course overview</template>
    <template #content>
      <div class="flex text-xs flex-col gap-3">
        <!-- Sessions -->
        <div class="gap-3 w-full inline-flex justify-between items-center">
          <span class="flex text-gray-600">Sessions</span>
          <span class="flex font-semibold">
            {{ this.$page.props.course.sessions_count }}
          </span>
        </div>

        <!-- Completed -->
        <div class="gap-3 w-full inline-flex justify-between items-center">
          <span class="flex text-gray-600">Completed</span>
          <span class="flex font-semibold">
            {{ this.completedSessions }}
          </span>
        </div>

        <!-- Reflections -->
        <div class="gap-3 w-full inline-flex justify-between items-center">
          <span class="flex text-gray-600">Reflections submitted</span>
          <span class="flex font-semibold">
            {{ this.submittedReflections }}
          </span>
        </div>

        <!-- Students enrolled -->
        <div class="gap-3 w-full inline-flex justify-between items-center">
          <span class="flex text-gray-600">Students enrolled</span>
          <span class="flex font-semibold">
            {{ this.$page.props.course.students_count }}
          </span>
        </div>
      </div>
    </template>
  </BoxCard>
</template>

<script>
import BoxCard from '@/Components/Cards/BoxCard.vue';

export default {
  name: 'CourseOverviewBox',
  components: {
    BoxCard,
  },
  data() {
    return {
      submittedReflections: this.$page.props.course.sessions.reduce(
        (sum, s) => sum + (s.reflections_count || 0),
        0,
      ),
      completedSessions: this.$page.props.course.sessions.filter((s) => s.finished_at !== null)
        .length,
    };
  },
};
</script>

<style scoped></style>
